export default [
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/sft/Profile.vue'),
    },
  ]